<template>
  <div class="register-con">
    <div class="logo-con">
      <img class="logo" :src="checkQiNiuUrl('anttalk/logo/ic_launcher.png?imageView2/2/w/256')" alt="">
      <div class="logo-text">AI app</div>
    </div>

<!--    <div class="yungan-text-con">-->
<!--      <span class="yungan-text">乡村振兴 · 共同富裕</span>-->
<!--    </div>-->

    <div class="btn-con">
      <van-button class="btn btn-2" round type="default"
                  :icon="checkQiNiuUrl('ant-wx/202208101113/android_icon_w.png')"
                  @click="onBtnClick(1)">Download APK</van-button>
    </div>



    <van-popup
        class="android-popup"
        v-model="androidPopupShow"
    >
      <div class="tip-icon"></div>
      <div class="tip-text">请选择 “在浏览器打开”</div>
    </van-popup>


  </div>
</template>

<script>
import preventBack from "vue-prevent-browser-back";
import { getAppVersion } from '@/api/uc'
export default {
  mixins: [preventBack],// 该页面禁止后退
  components: {
  },
  data(){
    return{
      origin: window.location.origin,
      androidPopupShow: false,
      isWechat: true,
      // app 下载链接
      androidUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.android.sdk.AntTalk',
      iosUrl: 'https://apps.apple.com/cn/app/云柑社区/id1457309964',
    }
  },
  created(){
    this.getAppVersion()
    this.openOther()
    window.setTimeout(()=>{
      document.body.scrollTop=document.documentElement.scrollTop=0
    },1000)
  },
  methods: {
    getAppVersion(){
      getAppVersion('anttalk', 'android').then(res=>{
        if(res.code===200){
          this.androidUrl = res.data.downloadUrl
        }
      })
      getAppVersion('anttalk', 'ios').then(res=>{
        if(res.code===200 && res.data.upgradePage){
          this.iosUrl = res.data.upgradePage
        }
      })
    },
    openOther(){
      let ua = navigator.userAgent.toLowerCase();
      this.isWechat = ua.indexOf('micromessenger')>0;
    },

    onBtnClick(type){
      if (type===1) {
        if(this.isWechat){
          this.androidPopupShow = true
        }else {
          window.location.href = this.androidUrl
        }
      } else { // ios
        window.location.href = this.iosUrl
      }
    },


  }
}
</script>

<style lang="less" scoped>
.register-con{
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  //background-color: #fff3e6;
  background: url("@{qnUrl}ant-wx/202208101113/wx_register_bg.png") no-repeat 0 0;
  background-size: 100% 100%;
  color: #333;
  .logo-con{
    width: 100%;
    padding-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo{
      width: 120px;
      height: 120px;
    }
    .logo-text{
      text-align: center;
      font-size: 18px;
      line-height: 35px;
      color: #fff;
    }
    &.user-con{
      .img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: 6px;
      }
      .nickname{
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        color: #000;
      }
      .text{
        text-align: center;
        font-size: 14px;
        color: #555;
      }
    }
  }

  .yungan-text-con{
    text-align: center;
    font-size: 26px;
    color: #fff;
  }

  .btn-con{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    .btn{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      background: transparent;
      margin-bottom: 20px;
      color: #fff;
      width: 315px;
      height: 50px;
      border-radius: 25px;
      border: 2px solid #ffffff;
      /deep/ .van-button__icon{
        width: 20px;
        height: 20px;
        .van-icon__image{
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .android-popup{
    background-color: transparent;transform: translate3d(0,0,0);top: 0;right: 0;left: 0;
    height: 160px;
    .tip-icon{
      position: absolute;right: 8px;top: 0;
      width: 64px;height: 100px;
      background: url("@{qnUrl}FtKqPlvv5ugcgA2b-kwYAJGktSRP") no-repeat 50% 50%;
      background-size: 100%;
    }
    .tip-text{color: #fff;font-size: 18px;position: absolute;top: 120px;right: 20px;}
  }

}
</style>
